import {
  MfaFactorCreateType,
  MfaFactorType,
  MfaFactorVerifyRequest
} from "@wingspanhq/wingspan-api-sdk";

export const ENROLLABLE_FACTOR_TYPES: MfaFactorCreateType[] = [
  MfaFactorCreateType.SMS,
  MfaFactorCreateType.EMAIL
];

export const mfaFactorTypeName = (type: string): string => {
  switch (type) {
    case MfaFactorCreateType.SMS:
      return "Text message (SMS)";
    case MfaFactorCreateType.EMAIL:
      return "Email";
    default:
      return "Verification method";
  }
};

export const mfaFactorVerifyCodeField = (
  type: MfaFactorType
): keyof MfaFactorVerifyRequest => {
  switch (type) {
    case MfaFactorType.SMS:
      return "smsCode";
    case MfaFactorType.EMAIL:
      return "emailCode";
    default:
      return "totpCode";
  }
};

export const mfaFactorVerifyPrompt = (
  type: MfaFactorType,
  destination: string
): string => {
  switch (type) {
    case MfaFactorType.SMS:
      return `Enter the 6-digit code we texted to ${destination}.`;
    case MfaFactorType.EMAIL:
      return `Enter the 6-digit code we emailed to ${destination}.`;
    default:
      return "Enter the 6-digit verification code.";
  }
};
